// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1S8Yx","selected":"Chip_selected__1fzIc"};